import { ReactNode } from "react";

interface MessageProps {
  /**
   * The message to display in the activity item.
   */
  children: ReactNode;
  /**
   * The class name of the message
   */
  className?: string;
}

export default function SupportingText({ children, className }: MessageProps) {
  return <div className={`text-sm text-secondary ${className ?? ""}`}>{children}</div>;
}

SupportingText.defaultProps = {
  className: undefined,
};
